import { $el, $elParent } from 'src/scripts/utils/utils'
import { BaseComponent } from '../base-component'

const CLOSE_BUTTON_SELECTOR = '[data-notification-close-button]'
const NOTIFICATION_ALERT_SELECTOR = '[data-notification-alert]'
const ALERT_TEXT_SELECTOR = '[data-notification-alert-text]'
const SCREEN_READER_ALERT_TEXT_SELECTOR =
  '[data-notification-screen-reader-alert-text]'

export class NotificationComponent extends BaseComponent {
  showTimeoutId: any

  mountComponent(): void {
    this.addListener(this, 'click', this.handleClick)
  }

  unmountComponent(): void {
    clearTimeout(this.showTimeoutId)
  }

  handleClick = (event: MouseEvent): void => {
    event.preventDefault()

    const button = $elParent(CLOSE_BUTTON_SELECTOR, event.target)

    if (button) {
      this.hide()
    }
  }

  show(
    errorText: string,
    variant: string = 'warning',
    duration: number = 3000,
  ): void {
    this.setAlert(errorText, variant)

    if (this.showTimeoutId) {
      clearTimeout(this.showTimeoutId)
    }

    this.setVisible(true)

    this.showTimeoutId = setTimeout(() => {
      this.setVisible(false)
    }, duration)
  }

  hide(): void {
    this.setVisible(false)
  }

  setVisible(isVisible: boolean): void {
    this.classList.toggle('is-visible', isVisible)
  }

  setAlert(errorText: string, variant: string): void {
    const alert = $el(NOTIFICATION_ALERT_SELECTOR, this)
    const text = $el(ALERT_TEXT_SELECTOR, this)
    const screenReaderText = $el(SCREEN_READER_ALERT_TEXT_SELECTOR, this)

    if (alert && text) {
      alert.setAttribute('alert-type', variant)
      text.innerHTML = errorText
      screenReaderText.innerHTML = errorText
    }
  }
}
